import AdaptedButton from 'components/Buttons/AdaptedButton'

/*
  A ação principal da tela: o Button `primary` do @cutilei/ui, com as props de antes do Design
  System. `dangerous` vira o `destructive` da lib, e `textColor` não tem mais efeito. As regras do
  tipo, do carregando e da largura estão no `AdaptedButton`.
*/
export default function MainButton({ dangerous = false, textColor, ...props }) {
  return <AdaptedButton {...props} variant='primary' destructive={dangerous}/>
}
